/**
 * The types of media processing executed by the system.
 */
export enum MediaProcessType {
  /**
   * Converts and compress a video message video file.
   */
  VideoMessage = 'video-message',

  /**
   * Converts and compress and generates a thumbnail image a video file.
   */
  Video = 'video',

  /**
   * A photograph, a picture produced using a camera, associated with a senior.
   */
  Photo = 'photo',

  /**
   * The act of making a picture with a pencil or pen.
   */
  Drawing = 'drawing',

  /**
   * A painting created on the device.
   */
  Painting = 'painting',

  /**
   * Stores Entity Service image to place on the app button.
   */
  EntityServiceImage = 'entity-service-image',

  /**
   * Stores an Entity picture, like a logo or something else representing the entity.
   */
  EntityPicture = 'entity-picture',

  /**
   * Stores Entity Services image to represent the entity services as a group.
   */
  EntityServicesImage = 'entity-services-image',

  /**
   * Stores an User picture, like a photograph or something else representing the user.
   */
  UserPicture = 'user-picture',

  /**
   * Upload a photo, related to an entity.
   */
  EntityPhoto = 'entity-photo',

  /**
   * Compress an image file.
   */
  PlaylistImage = 'playlist-image',

  /**
   * Compress an image file.
   */
  PlaylistItemThumbnailImage = 'playlist-item-thumbnail',
}
